<template>
  <el-config-provider :locale="locale">
    <div
      v-loading="userStore.loading"
      :element-loading-text="userStore.loadingTip"
      style="width: 100%; height: 100%"
    >
      <router-view />
      <global-setting />
    </div>
  </el-config-provider>
</template>

<script>
import enUS from "element-plus/es/locale/lang/en";
import zhCN from "element-plus/es/locale/lang/zh-cn";
import { ElMessageBox } from "element-plus";
import GlobalSetting from "@/components/global-setting/index.vue";
import { useUserStore } from "./store";

export default {
  components: { GlobalSetting },
  data() {
    return {
      userStore: useUserStore(),
      currentVersion: null,
      versionCheckInterval: null
    };
  },
  computed: {
    locale() {
      switch (this.$i18n.locale) {
        case "zh-CN":
          return zhCN;
        case "en-US":
          return enUS;
        default:
          return enUS;
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV === "production") {
      this.checkVersion();
      this.versionCheckInterval = setInterval(this.checkVersion, 60000);
    }
  },
  beforeUnmount() {
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval);
    }
  },
  methods: {
    async checkVersion() {
      try {
        const res = await fetch(`/version.json?_t=${Date.now()}`);
        const data = await res.json();
        if (!this.currentVersion) {
          this.currentVersion = data.hash;
          return;
        }
        if (data.hash !== this.currentVersion) {
          ElMessageBox.confirm(
            "系统已更新，是否刷新以加载新版本？",
            "提示",
            { confirmButtonText: "确定", closeOnClickModal: false }
          ).then(() => {
            clearInterval(this.versionCheckInterval);
            window.location.reload();
          });
        }
      } catch (err) {
        console.error("Version check failed:", err);
      }
    }
  }
};
</script>
